import React, { useState } from 'react';
import { Checkbox, FormControl, FormControlLabel, FormGroup, FormLabel, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface AgreementTermsViewProps {
  isControlParticipant: boolean;
  disabled?: boolean;
  onSelectedChange: (allSelected: boolean, agreementTerms: string[]) => void;
}

const AGREEMENT_TERM_CONFIRMED_CLINICAL_DIAGNOSIS = 'efConfirmedClinicalDiagnosis';
const AGREEMENT_TERM_AGREE_VIDEO_CAMERA = 'efAgreeVideoCamera';

const AgreementTermsView: React.FC<AgreementTermsViewProps> = ({ isControlParticipant, disabled, onSelectedChange }) => {
  const [confirmedClinicalDiagnosis, setConfirmedClinicalDiagnosis] = useState(false);
  const [agreeVideoCameraTurnOn, setAgreeVideoCameraTurnOn] = useState(false);
  const { t } = useTranslation('enrollment');

  const getAgreementTerms = (confirmedClinicalDiagnosis: boolean, agreeVideoCameraTurnOn: boolean) => {
    const terms: string[] = [];
    if (!isControlParticipant && confirmedClinicalDiagnosis) {
      terms.push(AGREEMENT_TERM_CONFIRMED_CLINICAL_DIAGNOSIS);
    }
    if (agreeVideoCameraTurnOn) {
      terms.push(AGREEMENT_TERM_AGREE_VIDEO_CAMERA);
    }
    return terms;
  };

  const updateState = (confirmedClinicalDiagnosis: boolean, agreeVideoCameraTurnOn: boolean) => {
    setConfirmedClinicalDiagnosis(confirmedClinicalDiagnosis);
    setAgreeVideoCameraTurnOn(agreeVideoCameraTurnOn);
    const allSelected = !isControlParticipant ? confirmedClinicalDiagnosis && agreeVideoCameraTurnOn : agreeVideoCameraTurnOn;
    onSelectedChange(allSelected, getAgreementTerms(confirmedClinicalDiagnosis, agreeVideoCameraTurnOn));
  };

  return (
    <FormControl component="fieldset" variant="standard" fullWidth>
      <FormLabel component="legend">
        <Typography variant="subtitle1" component="div"><strong>{t("I acknowledge that:")}</strong></Typography>
      </FormLabel>
      <FormGroup>
        {!isControlParticipant && (
          <FormControlLabel
            control={
              <Checkbox
                checked={confirmedClinicalDiagnosis}
                onChange={e => updateState(e.target.checked, agreeVideoCameraTurnOn)}
                disabled={disabled}
              />
            }
            label={t("I have a confirmed clinical diagnosis and proof of a disorder that qualifies me to participate in this study.")}
          />
        )}
        <FormControlLabel
          control={
            <Checkbox
              checked={agreeVideoCameraTurnOn}
              onChange={e => updateState(confirmedClinicalDiagnosis, e.target.checked)}
              disabled={disabled}
            />
          }
          label={t("I will need to have a video camera turned on during any interactions with the research team.")}
        />
      </FormGroup>
    </FormControl>
  );
};

export default AgreementTermsView;
